import React from "react";
import { Trans } from "react-i18next";
import { Link } from "react-router-dom";

/**
 * Чекбокс согласия с политикой/правилами.
 *
 * Props:
 * - checked: boolean                 // состояние галочки
 * - onChange: (bool) => void         // вызывается при смене
 * - id: string = "privacy"           // htmlFor-связка
 * - i18nKey: string = "signin.privacy" // ключ перевода с <offerLink/> и <privacyLink/>
 * - termsPath: string = "/document/terms"
 * - privacyPath: string = "/document/privacy"
 * - openInNewTab: boolean = false    // открывать документы в новой вкладке
 * - required: boolean = true
 * - className: string                // доп. классы контейнера
 * - extra: ReactNode                 // доп. контент под чекбоксом (например, ошибку)
 */
const PrivacyCheckbox = ({
                             checked,
                             onChange,
                             id = "privacy",
                             i18nKey = "signin.privacy",
                             termsPath = "/document/terms",
                             privacyPath = "/document/privacy",
                             openInNewTab = true,
                             required = true,
                             className = "",
                             extra,
                         }) => {
    // Вспомогательный компонент: Link внутри Trans (router Link или <a target="_blank">)
    const LinkOrA = ({ to, children, className: cls }) =>
        openInNewTab ? (
            <a href={to} target="_blank" rel="noreferrer" className={cls}>
                {children}
            </a>
        ) : (
            <Link to={to} className={cls}>
                {children}
            </Link>
        );

    return (
        <div className={`privacy-checkbox-container mt-7 ${className}`}>
            <input
                type="checkbox"
                id={id}
                checked={checked}
                onChange={(e) => onChange?.(e.target.checked)}
                required={required}
            />

            <label htmlFor={id}>
                <Trans
                    i18nKey={i18nKey}
                    components={{
                        offerLink: <LinkOrA to={termsPath} className="privacy-link text-blue-600" />,
                        privacyLink: <LinkOrA to={privacyPath} className="privacy-link text-blue-600" />,
                    }}
                />
            </label>

            {extra ? <div className="mt-1 text-xs text-red-500">{extra}</div> : null}
        </div>
    );
};

export default PrivacyCheckbox;
